import { PlatformComponent } from "./Model.model";
import { DataSrc } from "./workflow.model";

export class ParameterModel {
    model: PlatformComponent;
    parameterId;
    dataSource: DataSrc;
    dataSourceId;
    srcFrequency;
    srcParameterId;
    srcParameterName;
    defaultValue
  
  }